<template>
  <div :class="$options.name">
    <v-card>
      <import-data-table
        ref="importDataTable"
        :items="list"
        :current-page="pagination.currentPage"
        :last-page="pagination.lastPage"
        :loading="loading"
        @onDoReload="doReload"
      />
    </v-card>
  </div>
</template>

<script>

import ImportDataTable from '@/views/import-data/components/ImportDataTable.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'system-layer-objects-import',

  async asyncData({ store }) {
    const actions = [
      store.dispatch('importData/getList'),
    ];

    return Promise.all(actions);
  },

  components: {
    ImportDataTable,
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapState('importData', ['list', 'pagination']),
  },

  methods: {
    ...mapActions('importData', ['getList', 'getNextPage']),

    async doReload(params) {
      this.loading = true;

      await this.getNextPage({
        perPage: this.pagination.perPage,
        ...params,
      });

      this.loading = false;
    },
  },
};

</script>
